import { getUserIdWithFallback } from '../../../utils/getUserIdFromToken';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export interface EnrollAuthenticatorResponse {
  success: boolean;
  message?: string;
  id?: string;
}

/**
 * Enrolls authenticator for a guest using the correct user ID from JWT token
 * @param requestBody - Request payload with authenticator details
 * @returns Promise with enrollment response
 *
 * The user ID (mgmid) is automatically extracted from the JWT token's com.mgm.id claim.
 * This fixes the "mgmid in the token does not match the request" error.
 *
 * Note: Authorization header is automatically added by the http module from window.mgm.authClient
 */
export async function enrollAuthenticator(requestBody?: Record<string, unknown>): Promise<EnrollAuthenticatorResponse> {
  // Extract user ID from JWT token's com.mgm.id claim
  const mgmid = await getUserIdWithFallback();

  if (!mgmid) {
    throw new Error('Unable to extract user ID from token. Please ensure you are properly authenticated.');
  }

  try {
    console.log('🔐 Enrolling authenticator for user ID:', mgmid);

    const result = await post(`/guest/${mgmid}/authenticators/enroll`, {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
}

/**
 * @deprecated Use enrollAuthenticator() without mgmid parameter instead.
 * This function is kept for backward compatibility but will be removed in future versions.
 */
export async function enrollAuthenticatorLegacy(
  mgmid: string,
  requestBody?: Record<string, unknown>,
): Promise<EnrollAuthenticatorResponse> {
  console.warn('enrollAuthenticatorLegacy is deprecated. Use enrollAuthenticator() instead.');

  try {
    const result = await post(`/guest/${mgmid}/authenticators/enroll`, {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
}
